// extracted by mini-css-extract-plugin
export default {"acronym":"ExpandableLogo_acronym__jYM-i","first":"ExpandableLogo_first__IwE2J","rest":"ExpandableLogo_rest__OYskh"};